import React, { useState } from "react";
import { Container, Row, Col } from "reactstrap";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { LanguagesType } from "../../i18n/translate.dto";
import { setLanguage } from "../../redux/actions/language.actions";
import { setCountry } from "../../redux/actions/country.action";
import { FaInstagram, FaFacebook, FaLinkedin } from "react-icons/fa";

const FooterLanding: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const reduxState = useSelector((state: any) => state);
  const [selectedCountry, setSelectedCountry] = useState(reduxState.language || "es");

  const handleCountryChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const value = e.target.value;
    setSelectedCountry(value);
    dispatch(setLanguage(value));
    dispatch(setCountry(value));
  };

  return (
    <div style={styles.footerMainContainer}>
      <Container style={styles.newsletterSection}>
        <Row>
          <Col xl="6" lg="6" md="12" sm="12" xs="12" className="mb-4" style={{ paddingRight: "60px" }}>
            <h3 style={styles.newsletterTitle}>{t(LanguagesType.Landing_newsletter_title)}</h3>
            <p style={styles.newsletterSubtitle}>{t(LanguagesType.Landing_newsletter_subtitle)}</p>
            <input
              type="email"
              placeholder={t(LanguagesType.Landing_newsletter_email_placeholder) as string}
              style={styles.newsletterInput}
            />
            <div style={styles.checkboxContainer}>
              <input type="checkbox" id="privacy-checkbox" style={styles.checkbox} />
              <label htmlFor="privacy-checkbox" style={styles.newsletterDisclaimer}>
                {t(LanguagesType.Landing_newsletter_checkbox)}
              </label>
            </div>
            <p style={styles.countrySelector}>{t(LanguagesType.Landing_newsletter_country_label)}</p>
            <select style={styles.countrySelect} value={selectedCountry} onChange={handleCountryChange}>
              <option value="es">EUR € | ESPAÑA</option>
              <option value="pt">EUR € | PORTUGAL</option>
              <option value="uk">GBP £ | REINO UNIDO</option>
              <option value="it">EUR € | ITALIA</option>
              <option value="fr">EUR € | FRANCIA</option>
              <option value="mx">MXN $ | MÉXICO</option>
            </select>
          </Col>
          <Col xl="6" lg="6" md="12" sm="12" xs="12" className="mb-4" style={{ paddingLeft: "60px" }}>
            <h3 style={styles.newsletterTitle}>{t(LanguagesType.Landing_social_title)}</h3>
            <div style={styles.socialIcons}>
              <a href="https://instagram.com/flipoeyewear" target="_blank" rel="noopener noreferrer" style={styles.socialIconLink}>
                <div style={styles.socialIconCircle}><FaInstagram size={24} /></div>
              </a>
              <a href="https://facebook.com/flipoeyewear" target="_blank" rel="noopener noreferrer" style={styles.socialIconLink}>
                <div style={styles.socialIconCircle}><FaFacebook size={24} /></div>
              </a>
              <a href="https://www.linkedin.com/company/flipo-eyewear/posts/?feedView=all" target="_blank" rel="noopener noreferrer" style={styles.socialIconLink}>
                <div style={styles.socialIconCircle}><FaLinkedin size={24} /></div>
              </a>
            </div>
            <Row className="mt-4">
              <Col xs="6">
                <div style={styles.footerLinksColumn}>
                  <p style={styles.footerLinkItem}><a href="https://flipoeyewear.com/pages/suscripcion" style={styles.footerLink}>{t(LanguagesType.Landing_footer_plan)}</a></p>
                  <p style={styles.footerLinkItem}><a href="https://flipoeyewear.com/pages/faqs" style={styles.footerLink}>{t(LanguagesType.Landing_footer_faqs)}</a></p>
                  <p style={styles.footerLinkItem}><a href="https://flipoeyewear.com/pages/envios-y-devoluciones" style={styles.footerLink}>{t(LanguagesType.Landing_footer_shipping)}</a></p>
                </div>
              </Col>
              <Col xs="6">
                <div style={styles.footerLinksColumn}>
                  <p style={styles.footerLinkItem}><a href="https://flipoeyewear.com/pages/forma-de-pago" style={styles.footerLink}>{t(LanguagesType.Landing_footer_payment)}</a></p>
                  <p style={styles.footerLinkItem}><a href="https://flipoeyewear.com/pages/tarjetas-regalo" style={styles.footerLink}>{t(LanguagesType.Landing_footer_gift)}</a></p>
                  <p style={styles.footerLinkItem}><a href="https://flipoeyewear.com/pages/contacto" style={styles.footerLink}>{t(LanguagesType.Landing_footer_contact)}</a></p>
                  <p style={styles.footerLinkItem}><a href="https://flipoeyewear.com/pages/trabaja-con-nosotros" style={styles.footerLink}>{t(LanguagesType.Landing_footer_jobs)}</a></p>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>

      {/* Custom Footer */}
      <div style={styles.customFooter}>
        <Container>
          <Row>
            <Col xs="12" md="6" style={styles.footerCopyright}>
              <p style={styles.copyrightText}>{t(LanguagesType.Landing_copyright)}</p>
              <p style={styles.copyrightText}>{t(LanguagesType.Landing_copyright_rights)}</p>
            </Col>
            <Col xs="12" md="6">
              <div style={styles.footerLegalLinks}>
                <a href="https://flipoeyewear.com/policies/privacy-policy" style={styles.legalLink}>{t(LanguagesType.Landing_privacy)}</a>
                <a href="https://flipoeyewear.com/policies/shipping-policy" style={styles.legalLink}>{t(LanguagesType.Landing_shipping_policy)}</a>
                <a href="https://flipoeyewear.com/policies/terms-of-service" style={styles.legalLink}>{t(LanguagesType.Landing_terms)}</a>
                <a href="https://flipoeyewear.com/policies/contact-information" style={styles.legalLink}>{t(LanguagesType.Landing_contact_info)}</a>
                <a href="https://flipoeyewear.com/policies/legal-notice" style={styles.legalLink}>{t(LanguagesType.Landing_legal_notice)}</a>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

const styles: { [key: string]: React.CSSProperties } = {
  footerMainContainer: {
    backgroundColor: "#E5E5E5",
  },
  newsletterSection: {
    padding: "60px 20px 40px 20px",
    backgroundColor: "#E5E5E5",
  },
  newsletterTitle: {
    fontSize: "1.5rem",
    fontWeight: "400",
    marginBottom: "15px",
    fontFamily: "Outfit, sans-serif",
  },
  newsletterSubtitle: {
    fontSize: "0.95rem",
    marginBottom: "20px",
    fontFamily: "Outfit, sans-serif",
  },
  newsletterInput: {
    width: "100%",
    padding: "12px",
    border: "1px solid #CCCCCC",
    borderRadius: "0",
    marginBottom: "15px",
    fontFamily: "Outfit, sans-serif",
    backgroundColor: "#FFFFFF",
  },
  checkboxContainer: {
    display: "flex",
    alignItems: "flex-start",
    gap: "10px",
    marginBottom: "20px",
  },
  checkbox: {
    marginTop: "3px",
  },
  newsletterDisclaimer: {
    fontSize: "0.75rem",
    color: "#333",
    margin: 0,
    fontFamily: "Outfit, sans-serif",
    textAlign: "left",
  },
  countrySelector: {
    fontSize: "0.9rem",
    marginBottom: "10px",
    fontFamily: "Outfit, sans-serif",
    textAlign: "left",
  },
  countrySelect: {
    width: "100%",
    padding: "10px",
    border: "1px solid #CCCCCC",
    borderRadius: "0",
    fontFamily: "Outfit, sans-serif",
    backgroundColor: "#FFFFFF",
  },
  socialIcons: {
    display: "flex",
    gap: "15px",
    marginBottom: "30px",
  },
  socialIconLink: {
    textDecoration: "none",
  },
  socialIconCircle: {
    width: "45px",
    height: "45px",
    borderRadius: "50%",
    border: "2px solid #000000",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#000000",
    cursor: "pointer",
    transition: "all 0.3s ease",
  },
  footerLinksColumn: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  footerLinkItem: {
    margin: 0,
    padding: 0,
  },
  footerLink: {
    color: "#000000",
    textDecoration: "none",
    fontSize: "0.9rem",
    fontFamily: "Outfit, sans-serif",
  },
  customFooter: {
    backgroundColor: "#E5E5E5",
    color: "#FFFFFF",
    padding: "30px 0",
  },
  footerCopyright: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  copyrightText: {
    margin: "0",
    fontSize: "0.85rem",
    fontFamily: "Outfit, sans-serif",
    color: "#000000",
  },
  footerLegalLinks: {
    display: "flex",
    flexWrap: "wrap",
    gap: "20px",
    justifyContent: "flex-end",
    alignItems: "center",
  },
  legalLink: {
    color: "#000000",
    textDecoration: "none",
    fontSize: "0.8rem",
    fontFamily: "Outfit, sans-serif",
  },
};

export default FooterLanding;

